exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".igUPbReAe1niLlwtLhnaU{margin:-10px -10px 0}.igUPbReAe1niLlwtLhnaU.unlocked .react-draggable{cursor:move}.igUPbReAe1niLlwtLhnaU.locked .react-resizable-handle{display:none}.igUPbReAe1niLlwtLhnaU .react-grid-placeholder{background:#16ace3}.igUPbReAe1niLlwtLhnaU .actions{cursor:default}", ""]);

// exports
exports.locals = {
	"reactGridLayout": "igUPbReAe1niLlwtLhnaU"
};


//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/node_modules/css-loader!../graylog2-server/graylog2-web-interface/src/components/common/ReactGridContainer.css
// module id = 396
// module chunks = 0